import GetGestionesMixin from './get-gestiones-mixin';
import { getSedesPortal, getUnidadesNegocio, ID_SEDE_GRUPO_CORPORATIVO } from '../utils';
import configuraciones from '../services/configuraciones';

export default {
  mixins: [GetGestionesMixin],
  created() {
    this.obtenerGestiones();
    this.getSedes();
    this.getUnidadesNegocio();
  },
  data() {
    return {
      items: [],
      cargando: false,
      sedes: [],
      unidadesNegocio: [],
      mostrado: false,
      sedesSeleccionadas: [],
      estaActualizando: false,
    };
  },
  computed: {
    sedesAgrupadasPorUnidadNegocio() {
      const sedesAgrupadasPorUnidadNegocio = this.unidadesNegocio
        .map((unidadNegocio) => {
          const sedes = this.sedes.filter((sede) => sede.unidad_negocio == unidadNegocio.id);

          return {
            ...unidadNegocio,
            sedes,
          };
        })
        .filter((sedeAgrupada) => sedeAgrupada.sedes.length > 0);

      return sedesAgrupadasPorUnidadNegocio;
    },
    nombresSedesSeleccionadas() {
      return this.sedesSeleccionadas.length > 0
        ? this.sedes
            .filter((sede) => this.sedesSeleccionadas.includes(sede.id))
            .map((sede) => sede.nombre)
            .join(', ')
        : 'Ninguna';
    },
    sedesAgrupadas() {
      const sedesAgrupadas = [];
      this.sedesAgrupadasPorUnidadNegocio.forEach((sedeAgrupada, indice) => {
        const header = { header: sedeAgrupada.nombre };
        const sedes = sedeAgrupada.sedes.map((sede) => {
          return {
            id: sede.id,
            nombre: sede.nombre,
            group: sedeAgrupada.nombre,
          };
        });

        sedesAgrupadas.push(header, ...sedes);

        if (indice < this.sedesAgrupadasPorUnidadNegocio.length - 1) {
          sedesAgrupadas.push({ divider: true });
        }
      });

      return sedesAgrupadas;
    },
  },
  watch: {
    'gestion.numero': {
      handler: function (val) {
        if (val && this.sedesSeleccionadas.length > 0) {
          this.listar();
        }
      },
      immediate: true,
    },
  },
  methods: {
    async listarMixin(params) {
      this.items = [];

      if (this.sedesSeleccionadas.length == 0) {
        this.$notify({
          group: 'notifications',
          title: 'Error',
          text: 'Debe seleccionar al menos una sede para realizar la consulta',
          type: 'error',
        });

        return;
      }

      this.cargando = true;

      try {
        const respuesta = await this.getService({
          params,
        });

        this.$notify({
          group: 'notifications',
          title: 'Exito',
          text: 'Consulta realizada con éxito',
          type: 'success',
        });

        this.items = respuesta.data.datos;
        this.mostrado = false;
      } catch (error) {
        window.console.log(error);
      } finally {
        this.cargando = false;
      }
    },
    async getSedes() {
      try {
        const [respuestaUsuariosIdsAutorizadosSedeGrupoCorporativo, respuestaSedes] = await Promise.all([
          configuraciones.idsUsuariosAutorizadosParaSedeGrupoCorporativo(),
          getSedesPortal(this.$apollo),
        ]);
        const idsUsuariosAutorizados =
          respuestaUsuariosIdsAutorizadosSedeGrupoCorporativo?.data?.datos?.map((item) => item.id) || [];

        if (!idsUsuariosAutorizados.includes(this.$store.state.DATA_USER.id)) {
          this.sedes = respuestaSedes.data.getSedes.filter((sede) => sede.id != ID_SEDE_GRUPO_CORPORATIVO);
        } else {
          this.sedes = respuestaSedes.data.getSedes;
        }
      } catch (error) {
        window.console.log(error);
      }
    },
    async getUnidadesNegocio() {
      try {
        const respuesta = await getUnidadesNegocio(this.$apollo);

        this.unidadesNegocio = respuesta.data.NegociosAll;
      } catch (error) {
        window.console.log(error);
      }
    },
    aceptar() {
      this.listar();
    },
    agregarQuitarTodas(valor, sedes) {
      const sedesIds = sedes.map((sede) => sede.id);

      if (valor) {
        this.sedesSeleccionadas = [...this.sedesSeleccionadas, ...sedesIds];
      } else {
        this.sedesSeleccionadas = this.sedesSeleccionadas.filter((sedeId) => !sedesIds.includes(sedeId));
      }
    },
    removerSedeSeleccionada(item) {
      const index = this.sedesSeleccionadas.indexOf(item.id);
      if (index >= 0) {
        this.sedesSeleccionadas.splice(index, 1);

        this.listar();
      }
    },
  },
};
